import React, {useState} from 'react';
import {Box, Typography} from '@mui/material';
import {testAccountDetails} from '../../../tests/e2e/e2eCuroTestAccounts';
import {ScrollableModal} from '../Common/ScrollableModal';
import {AccountActionsModal} from './AccountActionsModal';
import {themeColors} from '../../theme/Theme';

interface TestAccountActionsProps {
  name: string;
  account: testAccountDetails;
  onCloseAllModals?: () => void;
}

export const TestAccountActions: React.FC<TestAccountActionsProps> = ({
  name,
  account,
  onCloseAllModals,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderTextWithColoredNumbers = (text: string, isBold = false) => {
    // Add spaces around SPP for better readability
    const textWithSpaces = text
      // .replace(/SPP/g, ' SPP ')
      // .replace(/SFP/g, ' SFP ')
      // .replace(/PAD/g, ' PAD ')
      // .replace(/DA/g, ' DA ')
      // .replace(/AR/g, ' AR ')
      // .replace(/\s+/g, ' ')
      .trim();
    const parts = textWithSpaces.split(/(\d+)/);
    return parts.map((part, _index) => {
      const key = `${textWithSpaces}-${part}-${part.length}`;
      if (/\d+/.test(part)) {
        return (
          <span key={key} style={{color: themeColors.coral}}>
            {isBold ? <strong>{part}</strong> : part}
          </span>
        );
      }
      return isBold ? <strong key={key}>{part}</strong> : part;
    });
  };

  return (
    <>
      <Box
        p={1}
        border="1px solid lightgrey"
        borderRadius={1}
        height="100%"
        display="flex"
        flexDirection="column"
        sx={{
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'action.hover',
            borderColor: 'primary.main',
          },
          transition: 'all 0.2s ease-in-out',
        }}
        onClick={() => setIsModalOpen(true)}
      >
        {name.toLocaleLowerCase().startsWith('regression') ? (
          <Typography variant="body2" mb={1}>
            Regression {renderTextWithColoredNumbers(name.substring(10), true)}
          </Typography>
        ) : (
          <Typography variant="body2" mb={1}>
            {renderTextWithColoredNumbers(name, true)}
          </Typography>
        )}

        <Typography variant="caption" color="text.secondary">
          {account.type.toUpperCase()}: {account.primarySimplifiedName}{' '}
          {account.secondaryName || ''}
        </Typography>
      </Box>

      <ScrollableModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="xlarge"
      >
        <AccountActionsModal
          name={name}
          account={account}
          onClose={() => setIsModalOpen(false)}
          onCloseAllModals={onCloseAllModals}
        />
      </ScrollableModal>
    </>
  );
};
